export default __webpack_public_path__ + "static/pulse_login-0fff32be305063fc7dcb3d2c0a9a22d6.jpeg";